import React from 'react';
import PropTypes from 'prop-types';

import Tag from '@decisiv/ui-components/lib/components/Tag';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import OverflowPopover from '../../shared/OverflowPopover';
import { PanelRow, TagRow } from '../../shared/styles';
import EMPTY_VALUE from '../../shared/emptyValue';

/**
 * The ACCOUNTS column: the first account inline, the rest behind a counted
 * chevron that expands to the same outline tags stacked one per row.
 */
function AccountsCell({ accounts }) {
  if (!accounts.length) {
    return <P shade={1}>{EMPTY_VALUE}</P>;
  }

  const [first, ...rest] = accounts;

  return (
    <TagRow>
      <Tag text={first} variant="outline" />
      {rest.length > 0 && (
        <OverflowPopover
          ariaLabel={`Show all accounts (${rest.length} more)`}
          summary={<Tag text={String(rest.length)} variant="outline" />}
        >
          {rest.map((account) => (
            <PanelRow key={account}>
              <Tag text={account} variant="outline" />
            </PanelRow>
          ))}
        </OverflowPopover>
      )}
    </TagRow>
  );
}

AccountsCell.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.string),
};

AccountsCell.defaultProps = {
  accounts: [],
};

export default AccountsCell;
